// Copyright (C) 2020-2022 Intel Corporation
//
// SPDX-License-Identifier: MIT

import React from 'react';
import Icon from '@ant-design/icons';

import { MagnetIcon } from 'icons';
import { Canvas } from 'cvat-canvas-wrapper';
import Popover from 'antd/lib/popover';
import withVisibilityHandling from './handle-popover-visibility';
import MagnetConfigPopoverContainer
    from '../../../../containers/annotation-page/standard-workspace/controls-side-bar/magnet-config-popover';

export interface Props {
    canvasInstance: Canvas;
    isDrawing: boolean;
    disabled?: boolean;
}

const CustomPopover = withVisibilityHandling(Popover, 'magnet-options');

function MagnetControl(props: Props): JSX.Element {
    const { isDrawing, disabled } = props;

    const dynamicPopoverProps = isDrawing ? {
        overlayStyle: {
            display: 'none',
        },
    } : {};

    const dynamicIconProps = isDrawing ? {
        className: 'cvat-magnet-control cvat-active-canvas-control',
    } : {
        className: 'cvat-magnet-control',
    };

    return disabled ? (
        <Icon className='cvat-magnet-control cvat-disabled-canvas-control' component={MagnetIcon} />
    ) : (
        <CustomPopover
            {...dynamicPopoverProps}
            overlayClassName='cvat-magnet-control-popover'
            placement='right'
            content={(
                <MagnetConfigPopoverContainer />
            )}
        >
            <Icon {...dynamicIconProps} component={MagnetIcon} />
        </CustomPopover>
    );
}

export default React.memo(MagnetControl);
